import {PageService, MovieService, PreviewService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
    mixins: [MetaData],
    data () {
        return {
            event: {},
            movie: null,
            loading: true,
            dialogActive: false
        }
    },

    methods: {

        getAsyncData(){
            this.metaTitle = this.event.title
            this.metaImage = this.event.og_image
            this.metaDescription = this.event.og_description
            this.schemaDataSrc = {
                "@context": "http://schema.org",
                "@type": "Event",
                "image": this.metaImage,
                "description": this.metaDescription,
                // "endDate": ""
                // "location": {
                //     "@type": "Place",
                //     "address": {
                //         "@type": "​PostalAddress​",
                //         "addressLocality": "​Denver​",
                //         "addressRegion": "​CO​",
                //         "postalCode": "​80209​",
                //         "streetAddress": "​7 S. Broadway​"
                //     },
                //     "name": "​The Hi-Dive​"
                // },
                "name": this.metaTitle,
                // "offers": {
                //     "@type": "Offer",
                //     "validFrom": "​2018-10-10​",
                //     "price": "​13.00​",
                //     "availability": "http://schema.org/InStock",
                //     "priceCurrency": "ZAR",
                //     "url": "​http://www.ticketfly.com/purchase/309433​"
                // },
                "startDate": this.event.event_date
            }
            this.$emit('updateHead');
        },

        processEvent(event){
            event.srcsets = event.mobile_image + ' 700w, ' + event.image + ' 2000w'
            this.event = event
            if (this.event.related_movie) this.getMovie(this.event.related_movie).then(()=>this.loading = false, ()=>this.loading = false)
            else
                this.loading = false;
        },
        getContent() {
            this.loading = true;
            if (PreviewService.hasPreviewContent('event') && PreviewService.getPreviewContent().nid === this.$route.params.id) {
                this.processEvent(PreviewService.getPreviewContent('event'));
            } else
                PageService.getEvent().then((response)=> {
                    response.forEach((el)=> {
                        if (el.nid === this.$route.params.id) {
                            this.processEvent(el)
                        }
                        this.getAsyncData()
                    })

                })
        },

        getMovie(id) {
            return MovieService.getMovieDetail(id).then((response)=> {
                this.movie = response
            })
        }
    },

    created(){
        this.getContent()
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/event/event.js